import styled, { css } from "styled-components"

import meshBgImg from "../images/bg/fabriq-mesh-bg-01.png"
import meshBgReverseImage from "../images/bg/fabriq-mesh-bg-01-reverse.png"
import meshBgTransImg from "../images/bg/fabriq-mesh-bg-02-trans.png"
import meshBgTransReverseImg from "../images/bg/fabriq-mesh-bg-02-trans-l2r.png"
import meshBgDarkImg from "../images/bg/fabriq-mesh-bg-dark-01.png"
import meshBgNavImg from "../images/bg/fabriq-mesh-bg-nav-01.png"
import meshBgNavReverseImg from "../images/bg/fabriq-mesh-bg-nav-01-reverse.png"


export const fabriqMeshBg = css`
  background-blend-mode: multiply;
  background: url(${meshBgImg}) bottom left no-repeat;
  background-size: cover;
  /* mask-image: linear-gradient(30deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0) 80%); */
`

export const FabriqMeshBgDiv = styled.div`
  background-blend-mode: multiply;
  background: url(${meshBgTransImg}) bottom left no-repeat;
  background-size: 30%;
  background-position: top right;
  background-color: white;
`

export const meshBorderImageStyles = {
  borderImage: `url(${meshBgImg}) 32 / 32px`
}

export const meshBgImageStyles = {
  background: `white url(${meshBgImg}) top right no-repeat`
}

export const mainContentBackgroundStyles = {
  background: `#F5F5F5 url(${meshBgImg}) top right no-repeat`,
  backgroundBlendMode: "darken"
}

export const meshBgImageUri = `url(${meshBgImg})`
export const meshBgImageReverseUri = `url(${meshBgReverseImage})`
export const meshBgTransImageUri = `url(${meshBgTransImg})`
export const meshBgDarkImageUri = `url(${meshBgDarkImg})`
export const meshBgNavImageUri = `url(${meshBgNavImg})`
export const meshBgHeaderImageReverseUri = `url(${meshBgTransReverseImg})`
export const meshBgNavReverseImageUri = `url(${meshBgNavReverseImg})`

export const meshBgMainContentAreaUri = `url(${meshBgImg})`

